"use client";
import React from "react";
import Switch from "@/components/ui/switch/Switch";
import { FacetItem } from "@/common/lib/types";

interface BooleanMapping {
  facetField: string;
  label: string;
  filterParams?: string;
}

export interface BooleanGroupListProps {
  booleanMappings: BooleanMapping[];
  facetMapping: FacetItem[];
  searchParams: Record<string, string>;
  translations: { singleItem: string; multipleItem: string };
  onChange: (key: string, value: string) => void;
}

const BooleanGroupList = ({
  booleanMappings,
  facetMapping,
  searchParams,
  translations,
  onChange,
}: BooleanGroupListProps) => {
  return (
    <>
      {booleanMappings.map((mapping, index) => {
        // Each child owns its URL key. Falling back to the group key made every
        // child share one param, so toggling one switched all of them on.
        const childKey = mapping.filterParams;
        if (!childKey) return null;

        const childSelected = searchParams?.[childKey]?.split("|") || [];
        const isChecked = childSelected.includes("true");
        const childItem = facetMapping?.find(
          (fm) => fm.facetField === mapping.facetField,
        );

        // Hide children with no matching products, unless already applied.
        if (!childItem?.count && !isChecked) return null;

        return (
          <React.Fragment key={mapping.facetField || index}>
            <div
              className="flex cursor-pointer items-center justify-between p-4"
              onClick={() => onChange(childKey, "true")}
            >
              <div className="flex flex-1 items-center justify-between">
                <p className="text-sm">{mapping.label || ""}</p>
                <div className="flex items-center">
                  <p className="me-2 text-xs text-tertiary-6">
                    {(childItem?.count || 0) > 1
                      ? translations.multipleItem?.replace(
                          "{{count}}",
                          `${childItem?.count || 0}`,
                        )
                      : translations.singleItem?.replace(
                          "{{count}}",
                          `${childItem?.count || 0}`,
                        )}
                  </p>
                  <Switch
                    bgClassName="has-[:checked]:bg-[#4285F4] bg-[#C4C4C4] pointer-events-none"
                    checked={isChecked}
                    onChange={() => {}}
                  />
                </div>
              </div>
            </div>
            <div className="mx-4 h-[1px] bg-tertiary-7" />
          </React.Fragment>
        );
      })}
    </>
  );
};

export default BooleanGroupList;
